import request from '@/utils/httpClient'

import { DeptModel } from '@/model/Index'
export const defaultDeptModel: DeptModel = {
  id: 0,
  superId: 0,
  superName: '',
  selected: false,
  name: '',
  nature: '',
  children: [],
  createUser: '',
  updateUser: '',
  createTime: '',
  updateTime: ''
}

// 创建部门
export function createDepartment(data?: object) {
  return request({
    url: 'dept',
    method: 'POST',
    data
  })
}

// 更新部门
export function updateDepartment(id: number, data?: object) {
  return request({
    url: `dept/${id}`,
    method: 'put',
    data
  })
}

// 批量删除部门
export function deleteDepartmentById(id: number) {
  return request({
    url: `dept/${id}`,
    method: 'delete'
  })
}

// 根据部门id获取该部门下的子部门
export function getDeptByDeptId(id: number, params?: object) {
  return request({
    url: `dept/list/${id}`,
    method: 'get',
    params
  })
}

// 根据部门id获取对应的label
export function getLabelByDeptId(id: number, params?: object) {
  return request({
    url: 'dept/dropdown',
    method: 'get',
    params
  })
}

// 获取部门tree
export function getDeptTree(params?: object) {
  return request({
    url: 'dept/tree',
    method: 'get',
    params
  })
}

// 获取部门详情
export function getDeptDetailByDeptId(id: number) {
  return request({
    url: `dept/${id}`,
    method: 'get'
  })
}
